exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-confirmation-tsx": () => import("./../../../src/pages/confirmation.tsx" /* webpackChunkName: "component---src-pages-confirmation-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-metal-tsx": () => import("./../../../src/pages/metal.tsx" /* webpackChunkName: "component---src-pages-metal-tsx" */),
  "component---src-templates-legal-template-tsx": () => import("./../../../src/templates/legal-template.tsx" /* webpackChunkName: "component---src-templates-legal-template-tsx" */)
}

